<template>
    <div >
        <c-rep-order-hum
            v-model   = "showHumOrderDialog"
            :incident = "incident"
            :data     = "data.order.hum"
        />

        <c-rep-order-ruv
            v-model   = "showRuvOrderDialog"
            :incident = "incident"
            :data     = "data.order.hum"
        />

        <v-menu
            close-on-click
            offset-x
            nudge-left="-10"
            nudge-top="10"
            v-model="printOpen"
            min-width="300"
            :close-on-content-click="false"
        >
            <template v-slot:activator="{ on: menu, attrs }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                        <v-btn
                            small
                            fab
                            v-bind="attrs"
                            v-on="{ ...tooltip, ...menu }"
                        >
                            <v-icon color="primary">mdi-printer</v-icon>
                        </v-btn>
                    </template>
                    <span>Dokumente drucken</span>
                </v-tooltip>
            </template>
            <c-column-header label="Dokument drucken" class="primary" title-border>
                <template v-slot:pre>
                    <div style="min-width: 18px"></div>
                </template>
            </c-column-header>
            <v-list>
                <v-list-item link @click="onPrint(100)" v-if="!isMaintanace">
                    <v-list-item-title>
                        Rechnungsprüfungsdeckblatt
                    </v-list-item-title>
                </v-list-item>
                <v-list-item link @click="onHumOrderDialog" v-if="isHum && !isMaintanace">
                    <v-list-item-title>
                        H&M Auftrag
                    </v-list-item-title>
                </v-list-item>
                <v-list-item link @click="onRuvOrderDialog" v-if="isRuv && !isMaintanace">
                    <v-list-item-title>
                        R+V Auftrag
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>

import Inc           from "@/modules/inc/service/Inc";
import Core          from "@/modules/core/service/Core";
import Report        from "@/modules/rep/service/Report";
import CColumnHeader from "@/modules/core/components/utils/CColumnHeader.vue";
import CRepOrderHum  from "@/modules/inc/reports/components/CRepOrderHum.vue";
import CRepOrderRuv from "@/modules/inc/reports/components/CRepOrderRuv.vue";

export default {
    name: "IncPrintButton",
    components: {
        CRepOrderRuv,
        CRepOrderHum,
        CColumnHeader,
    },
    props: {
        incident: {

        },

        index: {

        }
    },

    data: () => ({
        printOpen : false,
        showHumOrderDialog: false,
        showRuvOrderDialog: false,
        data: {
            order: {
                hum : null,
            }
        },

        customers: {
            hum: 205,
            ruv: 309
        }
    }),

    watch: {
        printOpen () {
            this.$emit("opend", this.printOpen)
        },
    },

    computed: {
        customer() {
            if (!this.incident || !this.incident.sites || this.incident.sites.length === 0) {
                return null;
            }

            return this.incident.sites[0].customer;
        },

        isHum () {
            return this.customer && this.customer.id === this.customers.hum;
        },

        isRuv () {
            return this.customer && this.customer.id === this.customers.ruv;
        },

        isMaintanace () {
            return this.incident.typeId === Inc.type.maintenanceProcess;
        }
    },

    methods: {
        onPrint (reportId) {
            Report.performPdf(reportId, this.incident.id, this.index, () => {
                this.printOpen = false,
                this.$bus.$emit(this.$events.refreshdocuments);
                this.$bus.$emit(Inc.events.journal);
            }, () => {
            })
        },

        onHumOrderDialog () {
            let bid = null;
            for (const step of this.incident.data) {
                if (step.bids) {
                    bid = step.bids[0];
                }
            }

            if (!bid) {
                Core.message.error(this, "Ereignis enthält kein Angebot");
                return;
            }

            const price = bid.priceRecommended ? bid.priceRecommended : bid.priceOriginal;
            if (!price) {
                Core.message.error(this, "Angebot enthält keinen Preis");
                return;
            }

            const reportId = price >= 10000 ? 102 : 101;
            Report.getData(reportId, this.incident.id, this.index).then(data => {
                this.data.order.hum = data;
                this.showHumOrderDialog = true;
            })
        },

        onRuvOrderDialog () {
            let bid = null;
            for (const step of this.incident.data) {
                if (step.bids) {
                    bid = step.bids[0];
                }
            }

            if (!bid) {
                Core.message.error(this, "Ereignis enthält kein Angebot");
                return;
            }

            const price = bid.priceRecommended ? bid.priceRecommended : bid.priceOriginal;
            if (!price) {
                Core.message.error(this, "Angebot enthält keinen Preis");
                return;
            }

            Report.getData(103, this.incident.id, this.index).then(data => {
                this.data.order.hum = data;
                this.showRuvOrderDialog = true;
            })
        }
    }
}
</script>
<style scoped>

</style>